<template>
  <div class="foot">
    <div class="foot-con">
      <img src />
      <div class="nav">
        <span>2024年版权信息</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  methods: {
    skipToTarget(t) {
      let routeUrl = this.$router.resolve({
        path: t
      });
      window.open(routeUrl.href, "_blank");
    }
  }
};
</script>

<style lang="less" scoped>
.foot {
  height: 49px;
  background: #1a1c20;
  position: relative;
  z-index: 99;
  .foot-con {
    width: 222px;
    margin: 0 auto;
    .nav {
      padding-left: 5px;

      span {
        color: #fff;
        // color: #996699;
        font-size: 14px;
        margin: 0 12px;
        cursor: pointer;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/foot.vue